import { render, staticRenderFns } from "./TheLayoutAuth.vue?vue&type=template&id=4cdd392d&"
import script from "./TheLayoutAuth.vue?vue&type=script&lang=js&"
export * from "./TheLayoutAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports